import { useEffect, useRef, useState } from 'react';
import { Menu, X, ArrowUpRight } from 'lucide-react';
import { Logo, AppLink } from './Primitives';
import { navigation, site } from '../../config/site';

export const Header = () => {
  const [open, setOpen] = useState(false);
  const button = useRef(null);
  const menu = useRef(null);
  const close = (restore = false) => { setOpen(false); if (restore) button.current?.focus(); };
  useEffect(() => {
    if (!open) return;
    menu.current?.querySelector('a')?.focus();
    const escape = (event) => { if (event.key === 'Escape') close(true); };
    const outside = (event) => {
      if (!menu.current?.contains(event.target) && !button.current?.contains(event.target)) close();
    };
    const resize = () => { if (window.innerWidth >= 1050) close(); };
    document.addEventListener('keydown', escape);
    document.addEventListener('pointerdown', outside);
    window.addEventListener('resize', resize);
    return () => {
      document.removeEventListener('keydown', escape);
      document.removeEventListener('pointerdown', outside);
      window.removeEventListener('resize', resize);
    };
  }, [open]);
  return <>
    <a href="#main-content" className="skip-link" data-testid="skip-to-content">Skip to content</a>
    <header className="site-header" data-testid="site-header">
      <div className="header-inner container">
        <Logo />
        <nav className="desktop-nav" aria-label="Main navigation" data-testid="desktop-navigation">
          {navigation.map(({ label, id }) => <a href={`/#${id}`} key={id} data-testid={`header-nav-${id}`}>{label}</a>)}
        </nav>
        <div className="header-actions">
          <a className="header-paper" href={site.whitepaper} data-testid="header-whitepaper-link">White paper<ArrowUpRight size={14} aria-hidden="true" /></a>
          <AppLink location="header" />
          <button className="menu-button" ref={button} aria-label={open ? 'Close navigation' : 'Open navigation'} aria-controls="mobile-navigation" aria-expanded={open} onClick={() => open ? close(true) : setOpen(true)} data-testid="mobile-menu-toggle">{open ? <X size={22} /> : <Menu size={22} />}</button>
        </div>
      </div>
      {open && <nav ref={menu} id="mobile-navigation" className="mobile-navigation" aria-label="Mobile navigation" data-testid="mobile-navigation" onBlur={(event) => {
        if (event.relatedTarget && !event.currentTarget.contains(event.relatedTarget) && event.relatedTarget !== button.current) close();
      }}>
        {navigation.map(({ label, id }, index) => <a key={id} href={`/#${id}`} onClick={() => close()} data-testid={`mobile-nav-${id}`}><span className="menu-index">0{index + 1}</span>{label}<ArrowUpRight size={20} aria-hidden="true" /></a>)}
        <a href={site.whitepaper} onClick={() => close()} data-testid="mobile-whitepaper-link"><span className="menu-index">05</span>White paper<ArrowUpRight size={20} aria-hidden="true" /></a>
      </nav>}
    </header>
  </>;
};